import Scrollbar from 'smooth-scrollbar';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

var modal = {
    selectors: {
        elements:   '[data-modal]',
        trigger:    '[data-modal-trigger]',
        target:     '[data-modal-target]',
        close:      '[data-modal-close]',
        navigation: '[data-modal-navigation]',
    },
    state: {
        $current: null
    },
    init: function() {
        var self  = this,
        $elements = $( self.selectors.elements );

        var $modalElement = $( '<div class="modal"><div class="modal__overlay" data-modal-close></div><div class="modal__content"></div></div>' );
        $( '#site' ).after( $modalElement );

        var $close = $( self.selectors.close );

        $( document.body ).on( 'click', self.selectors.trigger, function(e) {
            e.preventDefault();
            
            var $trigger = $( this ),
            $element     = $trigger.closest( self.selectors.elements ),
            $target      = $element.find( self.selectors.target );

            self.$current = $element;

            if ( window.theme.globals.disableClick === true ) {
                return false;
            }

            var modal = document.querySelector('.modal');
            disableBodyScroll( modal );

            $modalElement.children( '.modal__content' ).html( $target.html() );
            Scrollbar.init( document.querySelector( '.modal .modal__scroll' ) );

            var $images = $modalElement.find( 'img' );
            $images.each( function() {
                var $image = $( this );
                $image.attr( 'src', $image.attr( 'data-src' ) );
            } );

            setTimeout( function() {
                $( document.body ).addClass( 'modal-opened' );
            }, 100 );
        } );

        $modalElement.on( 'click', self.selectors.close, function(e) {
            e.preventDefault();

            var modal = document.querySelector('.modal');
            enableBodyScroll( modal );
            Scrollbar.destroy( document.querySelector( '.modal .modal__scroll' ) );

            $( document.body ).removeClass( 'modal-opened' );

            setTimeout( function() {
                enableBodyScroll( modal );
            }, 100 );

            return false;
        } );

        $modalElement.on( 'click', self.selectors.navigation, function(e) {
            e.preventDefault();

            var direction = $( this ).attr( 'data-modal-navigation' );

            var $element = direction === 'prev' ? self.$current.prev( self.selectors.elements ) : self.$current.next( self.selectors.elements ),
            $target   = $element.find( self.selectors.target );

            if ( $target.length < 1 ) {
                return;
            }

            self.$current = $element;

            $modalElement.children( '.modal__content' ).html( $target.html() );
            Scrollbar.init(document.querySelector( '.modal .modal__scroll' ) );
        } );
    }
}

export { modal };